var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clickable",on:{"click":function($event){return _vm.$emit('node-remove')}}},[_c('i',{staticClass:"mdi mdi-close-circle-outline"})])
}
var staticRenderFns = []

export { render, staticRenderFns }